import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserTie,
  faFileText,
  faFile,
  faClipboardQuestion,
  faBullseye,
  faUserFriends,
  faHouse,
  faCompress,
  faExpand,
  faChartColumn,
  faComment,
  faBoxesStacked,
} from "@fortawesome/free-solid-svg-icons";
import React, { useEffect, useState } from "react";
import { Button, Col, Container, Nav, OverlayTrigger, Row, Spinner, Tab, Tooltip } from "react-bootstrap";
import Assessments from "./assessments/Assessments";
import Documents from "./documents/Documents";
import Goals from "./goals/Goals";
import Messages from "./messages/Messages";
import Notes from "./notes/Notes";
import SupportUsers from "./support/SupportUsers";
import MyCaseTab from "./MyCaseTab";
import { useLocation, useParams } from "react-router-dom";
import { fetchUser, fetchUserCase, fetchConversations, fetchUserCaseGuardians, fetchUserCaseMembers } from "../../../services/httpClient";
import { User } from "../../../types/user";
import CaseReports from "./reports/CaseReports";
import HouseholdUsers from "./household/HouseholdUsers";
import useApp from "../../../utils/useApp";
import { unsavedChanges, currentUrl } from "../../../App";
import ToastMsg from "../../ui/ToastMsg";
import useMenuToggle from "../../../utils/useMenuToggle";
import { useNavigate } from "react-router-dom";
import NextMeetingCard from "../../ui/NextMeetingCard";
import Resources from "./resources/Resources";

const MyCase = () => {
  const navigate = useNavigate();
  const location = useLocation();
  currentUrl.value = location.pathname;
  const { id } = useParams();
  const queryParams = new URLSearchParams(location.search);
  const { auth, showMenu }: any = useApp();
  const toggle = useMenuToggle();
  const [toggleMenu, setToggleMenu] = useState<boolean>(toggle);
  const [navKey, setNavKey] = useState<string>("household");
  //set active states
  const [activeHousehold, setActiveHousehold] = useState(false);
  const [activeNotes, setActiveNotes] = useState(false);
  const [activeMessages, setActiveMessages] = useState(false);
  const [activeGoals, setActiveGoals] = useState(false);
  const [activeAssessment, setActiveAssessment] = useState(false);
  const [activeSupport, setActiveSupport] = useState(false);
  const [activeDocuments, setActiveDocuments] = useState(false);
  const [activeResources, setActiveResources] = useState(false);
  const [activeReports, setActiveReports] = useState(false);
  //get active tab data states
  const [getHouseholdData, setGetHouseholdData] = useState<boolean>(false);
  const [getNotesData, setGetNotesData] = useState(false);
  const [getMessagesData, setGetMessagesData] = useState(false);
  const [getGoalsData, setGetGoalsData] = useState(false);
  const [getAssessmentData, setGetAssessmentData] = useState(false);
  const [getSupportData, setGetSupportData] = useState(false);
  const [getDocumentsData, setGetDocumentsData] = useState(false);
  const [getResourcesData, setGetResourcesData] = useState(false);
  const [getReportsData, setGetReportsData] = useState(false);

  const [family, setFamily] = useState<any[]>([]);
  const [name, setName] = useState<string>();
  const [primaryCM, setPrimaryCM] = useState<any>();
  const [secondaryCM, setSecondaryCM] = useState<any>();
  const [isLoading, setIsLoading] = useState(false);
  const [myCase, setMyCase] = useState<boolean>(false);
  const [newMessage, setNewMessage] = useState<boolean>(false);
  const [userToSave, setUserToSave] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [showToast, setShowToast] = useState<boolean>(false);
  const [toastBody, setToastBody] = useState<string>("");
  const [toastText, setToastText] = useState<string>("");
  const [errMsg, setErrMsg] = useState("");

  //household states

  //note states
  const [createNote, setCreateNote] = useState<boolean>(false);
  const [viewNotes, setViewNotes] = useState<boolean>(true);
  const [editNote, setEditNote] = useState<boolean>(false);

  //messages states
  const [currentConversation, setCurrentConversation] = useState<any>({
    id: 0,
    name: "",
    participants: [auth?.profile.id],
  });

  //support states
  const [editUser, setEditUser] = useState<boolean>(false);
  const [currentUser, setCurrentUser] = useState<User>();
  const [addSupport, setAddSupport] = useState<boolean>(false);

  //assessment states
  const [viewAssessments, setViewAssessments] = useState(true);
  const [createAssessmentWell, setCreateAssessmentWell] = useState<boolean>(false);
  const [createAssessmentCont, setCreateAssessmentCont] = useState<boolean>(false);
  const [createAssessmentCustom, setCreateAssessmentCustom] = useState<boolean>(false);
  const [viewAssessmentWell, setViewAssessmentWell] = useState<boolean>(false);
  const [viewAssessmentCont, setViewAssessmentCont] = useState<boolean>(false);
  const [viewAssessmentCustom, setViewAssessmentCustom] = useState<boolean>(false);

  //goal states
  const [viewGoals, setViewGoals] = useState<boolean>(true);
  const [viewNextTasks, setViewNextTasks] = useState<boolean>(false);
  const [viewCompleted, setViewCompleted] = useState<boolean>(false);
  const [viewArchive, setViewArchive] = useState<boolean>(false);
  const [createGoal, setCreateGoal] = useState<boolean>(false);

  //resource states
  const [viewResources, setViewResources] = useState<boolean>(true);
  const [viewHistory, setViewHistory] = useState<boolean>(false);
  const [assignResource, setAssignResource] = useState<boolean>(false);

  useEffect(() => {
    const navKey = queryParams.get("key");

    if (navKey) {
      setNavKey(navKey);
      onNavClick(navKey);
    } else {
      onNavClick("household");
    }

    setIsLoading(true);
    getCase();
    getNewMessages();
    getFamily();
  }, []);

  function getCase() {
    fetchUserCase(id)
      .then((res: any) => {
        if (auth?.profile?.id === res[0].data?.primaryCM?.user_id || auth?.profile?.id === res[0].data?.secondaryCM?.user_id) {
          setMyCase(true);
        }

        setName(res[0].data.name);
        setPrimaryCM(res[0].data?.primaryCM);
        setSecondaryCM(res[0].data?.secondaryCM);
        setIsLoading(false);
      })
      .catch((err: any) => {
        console.log(err);
        setIsLoading(false);
      });
  }

  function getNewMessages() {
    fetchConversations(id)
      .then((res: any) => {
        const convList = res[0].data;
        const newMessageExists = convList.some((c: any) => c.new_messages === 1);

        if (auth?.profile?.role !== "support") {
          setNewMessage(newMessageExists);
        }
      })
      .catch((err: any) => {
        console.log(err);
        setIsLoading(false);
      });
  }

  function getFamily() {    
    fetchUserCaseGuardians(id, true)
      .then((res: any) => {
        const guardians = res[0].data;

        fetchUserCaseMembers(id, true)
          .then((res: any) => {
            const members = res[0].data;

            setFamily([...guardians, ...members]);
        });
      })
      .catch((err: any) => {
        console.log(err);
        setIsLoading(false);
      });
  }

  // if no name for a CM replace with email
  useEffect(() => {
    if (primaryCM?.user_name === " ") {
      fetchUser(primaryCM.user_id)
        .then((res: any) => {
          setPrimaryCM((prev: any) => ({
            ...prev,
            user_name: res[0].data.email,
          }));
        })
        .catch((err: any) => {
          console.log(err);
          setIsLoading(false);
        });
    }
    if (secondaryCM?.user_name === " ") {
      fetchUser(secondaryCM.user_id)
        .then((res: any) => {
          setSecondaryCM((prev: any) => ({
            ...prev,
            user_name: res[0].data.email,
          }));
        })
        .catch((err: any) => {
          console.log(err);
          setIsLoading(false);
        });
    }
  }, [primaryCM, secondaryCM]);

  useEffect(() => {
    if (userToSave) {
      unsavedChanges.value = true;
    } else {
      unsavedChanges.value = false;
    }
  }, [userToSave]);

  useEffect(() => {
    setToggleMenu(toggle);
  }, [toggle]);

  const onNavClick = (route: string | null) => {
    // if (route) {
    //   trackNavigationEvent("switch_view", "mycase_" + route);
    // }

    switch (route) {
      case "household":
        //set active tab
        setActiveHousehold(true);
        setActiveNotes(false);
        setActiveMessages(false);
        setActiveGoals(false);
        setActiveAssessment(false);
        setActiveSupport(false);
        setActiveDocuments(false);
        setActiveResources(false);
        setActiveReports(false);

        //get active tab data
        setGetHouseholdData(true);
        setGetNotesData(false);
        setGetMessagesData(false);
        setGetGoalsData(false);
        setGetAssessmentData(false);
        setGetSupportData(false);
        setGetDocumentsData(false);
        setGetResourcesData(false);
        setGetReportsData(false);
        break;
      case "notes":
        //set active tab
        setActiveHousehold(false);
        setActiveNotes(true);
        setActiveMessages(false);
        setActiveGoals(false);
        setActiveAssessment(false);
        setActiveSupport(false);
        setActiveDocuments(false);
        setActiveResources(false);
        setActiveReports(false);

        //get active tab data
        setGetHouseholdData(false);
        setGetNotesData(true);
        setGetMessagesData(false);
        setGetGoalsData(false);
        setGetAssessmentData(false);
        setGetSupportData(false);
        setGetDocumentsData(false);
        setGetResourcesData(false);
        setGetReportsData(false);

        //note states
        setCreateNote(false);
        setViewNotes(true);
        setEditNote(false);
        break;
      case "messages":
        //set active tab
        setActiveHousehold(false);
        setActiveNotes(false);
        setActiveMessages(true);
        setActiveGoals(false);
        setActiveAssessment(false);
        setActiveSupport(false);
        setActiveDocuments(false);
        setActiveResources(false);
        setActiveReports(false);

        //get active tab data
        setGetHouseholdData(false);
        setGetNotesData(false);
        setGetMessagesData(true);
        setGetGoalsData(false);
        setGetAssessmentData(false);
        setGetSupportData(false);
        setGetDocumentsData(false);
        setGetResourcesData(false);
        setGetReportsData(false);
        break;
      case "goals":
        //set active tab
        setActiveHousehold(false);
        setActiveNotes(false);
        setActiveMessages(false);
        setActiveGoals(true);
        setActiveAssessment(false);
        setActiveSupport(false);
        setActiveDocuments(false);
        setActiveResources(false);
        setActiveReports(false);

        //get active tab data
        setGetHouseholdData(false);
        setGetNotesData(false);
        setGetMessagesData(false);
        setGetGoalsData(true);
        setGetAssessmentData(false);
        setGetSupportData(false);
        setGetDocumentsData(false);
        setGetResourcesData(false);
        setGetReportsData(false);

        //goal states
        setViewGoals(true);
        setViewNextTasks(false);
        setViewCompleted(false);
        setViewArchive(false);
        setCreateGoal(false);
        break;
      case "assessment":
        //set active tab
        setActiveHousehold(false);
        setActiveNotes(false);
        setActiveMessages(false);
        setActiveGoals(false);
        setActiveAssessment(true);
        setActiveSupport(false);
        setActiveDocuments(false);
        setActiveResources(false);
        setActiveReports(false);

        //get active tab data
        setGetHouseholdData(false);
        setGetNotesData(false);
        setGetMessagesData(false);
        setGetGoalsData(false);
        setGetAssessmentData(true);
        setGetSupportData(false);
        setGetDocumentsData(false);
        setGetResourcesData(false);
        setGetReportsData(false);

        //assessment states
        setViewAssessments(true);
        setCreateAssessmentWell(false);
        setCreateAssessmentCont(false);
        setCreateAssessmentCustom(false);
        setViewAssessmentWell(false);
        setViewAssessmentCont(false);
        setViewAssessmentCustom(false);
        break;
      case "support":
        //set active tab
        setActiveHousehold(false);
        setActiveNotes(false);
        setActiveMessages(false);
        setActiveGoals(false);
        setActiveAssessment(false);
        setActiveSupport(true);
        setActiveDocuments(false);
        setActiveResources(false);
        setActiveReports(false);

        //get active tab data
        setGetHouseholdData(false);
        setGetNotesData(false);
        setGetMessagesData(false);
        setGetGoalsData(false);
        setGetAssessmentData(false);
        setGetSupportData(true);
        setGetDocumentsData(false);
        setGetResourcesData(false);
        setGetReportsData(false);

        //support states
        setEditUser(false);
        setCurrentUser(undefined);
        setAddSupport(false);
        break;
      case "documents":
        //set active tab
        setActiveHousehold(false);
        setActiveNotes(false);
        setActiveMessages(false);
        setActiveGoals(false);
        setActiveAssessment(false);
        setActiveSupport(false);
        setActiveDocuments(true);
        setActiveResources(false);
        setActiveReports(false);

        //get active tab data
        setGetHouseholdData(false);
        setGetNotesData(false);
        setGetMessagesData(false);
        setGetGoalsData(false);
        setGetAssessmentData(false);
        setGetSupportData(false);
        setGetDocumentsData(true);
        setGetResourcesData(false);
        setGetReportsData(false);
        break;
      case "resources":
        //set active tab
        setActiveHousehold(false);
        setActiveNotes(false);
        setActiveMessages(false);
        setActiveGoals(false);
        setActiveAssessment(false);
        setActiveSupport(false);
        setActiveDocuments(false);
        setActiveResources(true);
        setActiveReports(false);

        //get active tab data
        setGetHouseholdData(false);
        setGetNotesData(false);
        setGetMessagesData(false);
        setGetGoalsData(false);
        setGetAssessmentData(false);
        setGetSupportData(false);
        setGetDocumentsData(false);
        setGetResourcesData(true);
        setGetReportsData(false);

        //resource states
        setViewResources(true);
        setViewHistory(false);
        setAssignResource(false);
        break;
      case "reports":
        //set active tab
        setActiveHousehold(false);
        setActiveNotes(false);
        setActiveMessages(false);
        setActiveGoals(false);
        setActiveAssessment(false);
        setActiveSupport(false);
        setActiveDocuments(false);
        setActiveResources(false);
        setActiveReports(true);

        //get active tab data
        setGetHouseholdData(false);
        setGetNotesData(false);
        setGetMessagesData(false);
        setGetGoalsData(false);
        setGetAssessmentData(false);
        setGetSupportData(false);
        setGetDocumentsData(false);
        setGetResourcesData(false);
        setGetReportsData(true);
        break;
      default:
        setActiveHousehold(false);
        setActiveNotes(false);
        setActiveDocuments(false);
        setActiveSupport(false);
        setActiveAssessment(false);
        setActiveGoals(false);
        setActiveMessages(false);
        setActiveResources(false);
        setActiveReports(false);
        
        setGetHouseholdData(false);
        setGetNotesData(false);
        setGetMessagesData(false);
        setGetGoalsData(false);
        setGetAssessmentData(false);
        setGetSupportData(false);
        setGetDocumentsData(false);
        setGetResourcesData(false);
        setGetReportsData(false);
        break;
    }
  };

  return (
    <>
      <ToastMsg showToast={showToast} setShowToast={setShowToast} toastText={toastText} toastBody={toastBody} />

      {isLoading ? (
        <Container className="div-main">
          <Button size="sm" className="spinner-button spinner-button-main">
            <Spinner animation="border" style={{ color: "#F6893D" }} />
          </Button>
        </Container>
      ) : (
        <Container className={showMenu ? "md div-main-menu custom-container" : "md div-main custom-container"}>
          <Row className="justify-content-start">
            <Tab.Container defaultActiveKey={navKey}>
              <Col sm={toggleMenu ? 3 : 1}>
                <Nav
                  variant="pills"
                  className={showMenu ? "flex-column sticky-top mycase-menu-open-sticky" : "flex-column sticky-top mycase-menu-sticky"}
                >
                  <Nav.Item className="mb-2">
                    {toggleMenu ? (
                      (name || "").length < 16 ? (
                        <Row>
                          <Col className="col-8">
                            <div style={{ display: "flex", alignItems: "center", height: "100%" }}>
                              <h2
                                className="hero-heading font-size-dynamic-heading app-header-text"
                                style={{ margin: 0, width: "100%", whiteSpace: "nowrap" }}
                                onClick={() => navigate("/my-cases")}
                              >
                                {name}
                              </h2>
                            </div>
                          </Col>
                          <Col className="text-end col-4 pe-1">
                            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-home">My Cases</Tooltip>}>
                              <Button onClick={() => navigate("/my-cases")} className="app-primary-color button me-2">
                                <FontAwesomeIcon icon={faHouse}></FontAwesomeIcon>
                              </Button>
                            </OverlayTrigger>
                          </Col>
                        </Row>
                      ) : (
                        <Row>
                          <Col className="col-8">
                            <div style={{ display: "flex", alignItems: "center", height: "100%" }}>
                              <h2
                                className={
                                  (name ?? "").split(" ").some((part) => part.length >= 16)
                                    ? "hero-heading font-size-dynamic-larger app-header-text"
                                    : "hero-heading font-size-dynamic-heading app-header-text"
                                }
                                onClick={() => navigate("/my-cases")}
                              >
                                {name}
                              </h2>
                            </div>
                          </Col>
                          <Col className="text-end col-4 pe-1">
                            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-home">My Cases</Tooltip>}>
                              <Button onClick={() => navigate("/my-cases")} className="app-primary-color button me-2">
                                <FontAwesomeIcon icon={faHouse}></FontAwesomeIcon>
                              </Button>
                            </OverlayTrigger>
                          </Col>
                        </Row>
                      )
                    ) : (
                      <>
                        <p className="font-size-dynamic-heading fw-semibold app-header-text" onClick={() => navigate("/my-cases")}>
                          {name}
                        </p>
                        <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-home">My Cases</Tooltip>}>
                          <Button onClick={() => navigate("/my-cases")} className="app-primary-color button me-2">
                            <FontAwesomeIcon icon={faHouse}></FontAwesomeIcon>
                          </Button>
                        </OverlayTrigger>
                      </>
                    )}
                  </Nav.Item>
                  <Nav.Item className={toggleMenu ? "d-block" : "d-grid"}>
                    <Nav.Link
                      data-testid="household-tab"
                      eventKey="household"
                      className={activeHousehold ? "nav-vertical-active" : "nav-vertical"}
                      onClick={() => onNavClick("household")}
                      disabled={userToSave ? true : false}
                    >
                      <>
                        <FontAwesomeIcon icon={faUserFriends} className={toggleMenu ? "me-2" : "me-0"} />
                        {toggleMenu ? "Household" : ""}
                      </>
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item className={toggleMenu ? "d-block" : "d-grid"}>
                    <Nav.Link
                      data-testid="note-tab"
                      eventKey="notes"
                      className={activeNotes ? "nav-vertical-active" : "nav-vertical"}
                      onClick={() => onNavClick("notes")}
                      disabled={userToSave ? true : false}
                    >
                      <>
                        <FontAwesomeIcon icon={faFileText} className={toggleMenu ? "me-2" : "me-0"} />
                        {toggleMenu ? "Notes" : ""}
                      </>
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item className={toggleMenu ? "d-block" : "d-grid"}>
                    <Nav.Link
                      data-testid="message-tab"
                      eventKey="messages"
                      className={activeMessages ? "nav-vertical-active" : "nav-vertical"}
                      onClick={() => onNavClick("messages")}
                      disabled={userToSave ? true : false}
                    >
                      <>
                        {newMessage ? (
                          <FontAwesomeIcon icon={faComment} className={toggleMenu ? "me-2 app-orange-text" : "me-0 app-orange-text"} />
                        ) : (
                          <FontAwesomeIcon icon={faComment} className={toggleMenu ? "me-2" : "me-0"} />
                        )}
                        {toggleMenu ? "Messages" : ""}
                        {/* {newMessage && toggleMenu && !activeMessages && (
                          <Badge bg="tertiary" className="app-tertiary-color ms-2">
                            New
                          </Badge>
                        )} */}
                      </>
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item className={toggleMenu ? "d-block" : "d-grid"}>
                    <Nav.Link
                      data-testid="goal-tab"
                      eventKey="goals"
                      className={activeGoals ? "nav-vertical-active" : "nav-vertical"}
                      onClick={() => onNavClick("goals")}
                      disabled={userToSave ? true : false}
                    >
                      <>
                        <FontAwesomeIcon icon={faBullseye} className={toggleMenu ? "me-2" : "me-0"} />
                        {toggleMenu ? "Goals" : ""}
                      </>
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item className={toggleMenu ? "d-block" : "d-grid"}>
                    <Nav.Link
                      data-testid="assessment-tab"
                      eventKey="assessment"
                      className={activeAssessment ? "nav-vertical-active" : "nav-vertical"}
                      onClick={() => onNavClick("assessment")}
                      disabled={userToSave ? true : false}
                    >
                      <>
                        <FontAwesomeIcon icon={faClipboardQuestion} className={toggleMenu ? "me-2" : "me-0"} />
                        {toggleMenu ? "Assessments" : ""}
                      </>
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item className={toggleMenu ? "d-block" : "d-grid"}>
                    <Nav.Link
                      data-testid="support-tab"
                      eventKey="support"
                      className={activeSupport ? "nav-vertical-active" : "nav-vertical"}
                      onClick={() => onNavClick("support")}
                      disabled={userToSave ? true : false}
                    >
                      <>
                        <FontAwesomeIcon icon={faUserTie} className={toggleMenu ? "me-2" : "me-0"} />
                        {toggleMenu ? "Support" : ""}
                      </>
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item className={toggleMenu ? "d-block" : "d-grid"}>
                    <Nav.Link
                      data-testid="document-tab"
                      eventKey="documents"
                      className={activeDocuments ? "nav-vertical-active" : "nav-vertical"}
                      onClick={() => onNavClick("documents")}
                      disabled={userToSave ? true : false}
                    >
                      <>
                        <FontAwesomeIcon icon={faFile} className={toggleMenu ? "me-2" : "me-0"} />
                        {toggleMenu ? "Documents" : ""}
                      </>
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item className={toggleMenu ? "d-block" : "d-grid"}>
                    <Nav.Link
                      eventKey="resources"
                      className={activeResources ? "nav-vertical-active" : "nav-vertical"}
                      onClick={() => onNavClick("resources")}
                      disabled={userToSave ? true : false}
                    >
                      <>
                        <FontAwesomeIcon icon={faBoxesStacked} className={toggleMenu ? "me-2" : "me-0"} />
                        {toggleMenu ? "Resources" : ""}
                      </>
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item className={toggleMenu ? "d-block" : "d-grid"}>
                    <Nav.Link
                      data-testid="report-tab"
                      eventKey="reports"
                      className={activeReports ? "nav-vertical-active" : "nav-vertical"}
                      onClick={() => onNavClick("reports")}
                      disabled={userToSave ? true : false}
                    >
                      <>
                        <FontAwesomeIcon icon={faChartColumn} className={toggleMenu ? "me-2" : "me-0"} />
                        {toggleMenu ? "Reports" : ""}
                      </>
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={<Tooltip>Collapse/Expand</Tooltip>}>
                      <Button onClick={() => setToggleMenu(!toggleMenu)} className="button app-tertiary-color mb-2 mt-2">
                        {toggleMenu ? <FontAwesomeIcon icon={faCompress} /> : <FontAwesomeIcon icon={faExpand} className="me-0" />}
                      </Button>
                    </OverlayTrigger>
                  </Nav.Item>
                  {toggleMenu && (
                    <div
                      className={
                        showMenu ? "flex-column sticky-top mycase-date-open-sticky mt-3" : "flex-column sticky-top mycase-date-sticky mt-3"
                      }
                    >
                      <NextMeetingCard
                        id={id}
                        setShowToast={setShowToast}
                        setToastText={setToastText}
                        setToastBody={setToastBody}
                        setErrMsg={setErrMsg}
                        family={family}
                      />
                    </div>
                  )}
                </Nav>
              </Col>
              <Col xs={toggleMenu ? 9 : 11} className="mt-2">
                <Tab.Content>
                  <Tab.Pane eventKey="household" className="pb-5">
                    <MyCaseTab
                      component={
                        <HouseholdUsers
                          myCase={myCase}
                          userToSave={userToSave}
                          setUserToSave={setUserToSave}
                          showModal={showModal}
                          setShowModal={setShowModal}
                          getData={getHouseholdData}
                          family={family}
                          getFamily={getFamily}
                        />
                      }
                    />
                  </Tab.Pane>
                  <Tab.Pane eventKey="notes" className="pb-5">
                    <MyCaseTab
                      component={
                        <Notes
                          createNote={createNote}
                          setCreateNote={setCreateNote}
                          viewNotes={viewNotes}
                          setViewNotes={setViewNotes}
                          editNote={editNote}
                          setEditNote={setEditNote}
                          myCase={myCase}
                          setUserToSave={setUserToSave}
                          showModal={showModal}
                          setShowModal={setShowModal}
                          getData={getNotesData}
                          family={family}
                        />
                      }
                    />
                  </Tab.Pane>
                  <Tab.Pane eventKey="messages" className="pb-5">
                    <MyCaseTab
                      component={
                        <Messages
                          currentConversation={currentConversation}
                          setCurrentConversation={setCurrentConversation}
                          setNewMessage={setNewMessage}
                          primaryCM={primaryCM}
                          secondaryCM={secondaryCM}
                          getData={getMessagesData}
                          myCase={myCase}
                        />
                      }
                    />
                  </Tab.Pane>
                  <Tab.Pane eventKey="goals">
                    <MyCaseTab
                      component={
                        <Goals
                          viewGoals={viewGoals}
                          setViewGoals={setViewGoals}
                          viewNextTasks={viewNextTasks}
                          setViewNextTasks={setViewNextTasks}
                          viewCompleted={viewCompleted}
                          setViewCompleted={setViewCompleted}
                          viewArchive={viewArchive}
                          setViewArchive={setViewArchive}
                          createGoal={createGoal}
                          setCreateGoal={setCreateGoal}
                          getData={getGoalsData}
                          myCase={myCase}
                          family={family}
                        />
                      }
                    />
                  </Tab.Pane>
                  <Tab.Pane eventKey="assessment">
                    <MyCaseTab
                      component={
                        <Assessments
                          viewAssessments={viewAssessments}
                          setViewAssessments={setViewAssessments}
                          createAssessmentWell={createAssessmentWell}
                          setCreateAssessmentWell={setCreateAssessmentWell}
                          createAssessmentCont={createAssessmentCont}
                          setCreateAssessmentCont={setCreateAssessmentCont}
                          createAssessmentCustom={createAssessmentCustom}
                          setCreateAssessmentCustom={setCreateAssessmentCustom}
                          viewAssessmentWell={viewAssessmentWell}
                          setViewAssessmentWell={setViewAssessmentWell}
                          viewAssessmentCont={viewAssessmentCont}
                          setViewAssessmentCont={setViewAssessmentCont}
                          viewAssessmentCustom={viewAssessmentCustom}
                          setViewAssessmentCustom={setViewAssessmentCustom}
                          getData={getAssessmentData}
                          myCase={myCase}
                          family={family}
                        />
                      }
                    />
                  </Tab.Pane>
                  <Tab.Pane eventKey="support">
                    <MyCaseTab
                      component={
                        <SupportUsers
                          editUser={editUser}
                          setEditUser={setEditUser}
                          currentUser={currentUser}
                          setCurrentUser={setCurrentUser}
                          addSupport={addSupport}
                          setAddSupport={setAddSupport}
                          getData={getSupportData}
                          myCase={myCase}
                        />
                      }
                    />
                  </Tab.Pane>
                  <Tab.Pane eventKey="documents">
                    <MyCaseTab component={<Documents getData={getDocumentsData} myCase={myCase} setUserToSave={setUserToSave} />} />
                  </Tab.Pane>
                  <Tab.Pane eventKey="resources">
                    <MyCaseTab
                      component={
                        <Resources
                          viewResources={viewResources}
                          setViewResources={setViewResources}
                          viewHistory={viewHistory}
                          setViewHistory={setViewHistory}
                          assignResource={assignResource}
                          setAssignResource={setAssignResource}
                          getData={getResourcesData}
                          family={family}
                        />
                      }
                    />
                  </Tab.Pane>
                  <Tab.Pane eventKey="reports">
                    <MyCaseTab component={<CaseReports getData={getReportsData} />} />
                  </Tab.Pane>
                </Tab.Content>
              </Col>
            </Tab.Container>
          </Row>
        </Container>
      )}
    </>
  );
};

export default MyCase;
